import React, { useEffect }  from "react";
import { connect } from "react-redux";
import EmployeeDirectory from "./components/EmployeeDirectory";
import { 
  UserPlus,
  Users,
  UserMinus,
} from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import {
  getEmployeeStat
} from "../../../../redux/employee/employeeState";

const EmployeeDetails = ({
  getStats,
  recordStat
}) => {

  useEffect(() => {
    getStats();
  },[getStats]);

  return (
    <div className="space-y-6">
      <SummaryHeader
          title={"Employees"}
          icon={Users}
          description={"Quickly find and connect with team members"}
          color={"blue"}
      >
          <div className="summary-item-container">
              <SummaryItem
                  title="Active Employees"
                  icon={<UserPlus />}
                  display={recordStat?.active}
              />
              <SummaryItem
                  title="Separated Employees"
                  icon={<UserMinus />}
                  display={recordStat?.separated}
              />
          </div>
      </SummaryHeader>
      <div className="grid h-full grid-cols-1 gap-4">
        <EmployeeDirectory/>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordStat: state.employee.employeeStat.data,
});

const mapDispatchToProps = (dispatch) => ({
  getStats: (data) => dispatch(getEmployeeStat(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDetails);